import { Bounce, LightSpeed, Zoom } from "react-reveal";
import { Container, Row, Col, Image } from "react-bootstrap";
import { StyledSection, StyledParallex } from "./home-screen-section-styles";
import HomeImg1 from "../../assets/images/homeImage1.jpg";
import HomeImg2 from "../../assets/images/hommi2.png";
import HomeImg3 from "../../assets/images/hommi1.png";
import ArrowImg from "../../assets/images/arrow.png";
import { Link } from "react-router-dom";

const HomeScreenSection = () => {
  return (
    <>
      <StyledSection>
        <Container>
          <Row className="align-items-center pt-5 gx-5 gy-5">
            <Col xs={12} sm={12} md={6}>
              <Bounce left>
                <h1>Medical procurement made easy </h1>
              </Bounce>

              <Bounce top>
                <p className="mt-2">
                  We help connect medical suppliers with health facilities such
                  as hospital and pharmacies
                </p>
              </Bounce>
              <LightSpeed left>
                <button className="styled-button mt-3">Join Us</button>
              </LightSpeed>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <LightSpeed right>
                <Image src={HomeImg1} alt="image1" width="100%" height="auto" />
              </LightSpeed>
            </Col>
          </Row>
        </Container>
      </StyledSection>

      <StyledParallex></StyledParallex>
      <StyledSection>
        <Container>
          <Row className="align-items-center gy-5 mt-5">
            <Col xs={12} sm={12} md={5} className="text-center">
              <Zoom left>
                <Col>
                  <Image
                    src={HomeImg3}
                    alt="image1"
                    width="100%"
                    height="auto"
                  />
                </Col>
                <Row className="mt-5">
                  <Col className="d-flex justify-content-center">
                    <Image
                      src={ArrowImg}
                      alt="image2"
                      width="25px"
                      height="auto"
                    />

                    <Link to="/medical-suppliers">
                      <span>Suppliers</span>
                    </Link>
                  </Col>
                </Row>
              </Zoom>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={{ span: 5, offset: 2 }}
              className="text-center"
            >
              <Zoom right>
                <Col>
                  <Image
                    src={HomeImg2}
                    alt="image1"
                    width="100%"
                    height="auto"
                  />
                </Col>
                <Row className="mt-5">
                  <Col className="d-flex justify-content-center">
                    <Image
                      src={ArrowImg}
                      alt="image1"
                      width="25px"
                      height="auto"
                    />
                    <Link to="/health-facilities">
                      <span>Health facilities</span>
                    </Link>
                  </Col>
                </Row>
              </Zoom>
            </Col>
          </Row>
        </Container>
      </StyledSection>
    </>
  );
};

export default HomeScreenSection;
